import React from 'react';
import { Screens } from './screens'
import './app.css'



function App() {
  return (
    <div className="App">
      <Screens />

    </div>
  );
}

export default App;
